import { useQuery } from "@tanstack/react-query";
import type { Address } from "viem";
import type { RedKeel } from "../config/networks";
import { clientePublico } from "../lib/cliente";

// Selector de `recenterTight(uint256,uint256)`. Los vaults viejos NO lo tienen en su bytecode (su
// cascarón es fijo); solo los desplegados con la lógica nueva. Buscarlo en el código es la forma
// fiable de saber si el botón «Volver al rango estrecho» va a funcionar en ESTE vault.
const SELECTOR = "f4d90e3b";

export function useSoportaRecenter(vault: Address | undefined, red: RedKeel | undefined) {
  return useQuery({
    queryKey: ["soporta-recenter", red?.clave, vault],
    enabled: !!vault && !!red,
    staleTime: Infinity,
    queryFn: async (): Promise<boolean> => {
      const code = await clientePublico(red!.idCadena).getBytecode({ address: vault! });
      return !!code && code.toLowerCase().includes(SELECTOR);
    },
  });
}
